import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../../../../components/header/quick-create/PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddNewFromCustomerForm } from '../../../../components/AddOrder/AddNewFromCustomerForm'

export const OrderPopUp = () => {
  const { menuTarget, open, onSuccessSubmit } = useContext()

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.orderCustomer && open} target={menuTarget?.target}>
      <AddNewFromCustomerForm onSuccessSubmit={onSuccessSubmit} />
    </PopUpContainer>
  )
}
